import "/opt/www/game/xcp-vue-xc01/node_modules/core-js/modules/es.array.iterator.js";
import "/opt/www/game/xcp-vue-xc01/node_modules/core-js/modules/es.promise.js";
import "/opt/www/game/xcp-vue-xc01/node_modules/core-js/modules/es.object.assign.js";
import "/opt/www/game/xcp-vue-xc01/node_modules/core-js/modules/es.promise.finally.js";
import Vue from 'vue';
import App from './App.vue';
// 引入element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 全局配置elementui的dialog不能通过点击遮罩层关闭
ElementUI.Dialog.props.closeOnClickModal.default = false;
Vue.use(ElementUI);
// 引入封装的router
import router from '@/router/index';

// time line css
import '../node_modules/timeline-vuejs/dist/timeline-vuejs.css';
import '@/permission';
import { store } from '@/store/index';
Vue.config.productionTip = false;

// 路由守卫
import Bus from '@/utils/bus.js';
Vue.use(Bus);
import APlayer from '@moefe/vue-aplayer';
Vue.use(APlayer, {
  defaultCover: 'https://github.com/u3u.png',
  productionTip: true
});

// 引入VXETable
import XEUtils from 'xe-utils';
import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';
Vue.use(VXETable);
Vue.prototype.$utils = XEUtils;
Vue.prototype.$XModal = VXETable.modal;
Vue.prototype.$XPrint = VXETable.print;
Vue.prototype.$XSaveFile = VXETable.saveFile;
Vue.prototype.$XReadFile = VXETable.readFile;

// 引入Treeselect
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
Vue.component('Treeselect', Treeselect);

// 导入moment
import moment from 'moment';
Vue.prototype.$moment = moment;
moment.locale('zh-cn');
// 按钮权限指令
import { auth } from '@/directive/auth';
auth(Vue);
import uploader from 'vue-simple-uploader';
Vue.use(uploader);
export default new Vue({
  render: function render(h) {
    return h(App);
  },
  router: router,
  store: store
}).$mount('#app');

//引入echarts
import echarts from 'echarts';
Vue.prototype.$echarts = echarts;
Vue.config.devtools = true;
import cal from '@/utils/calculation';
Vue.prototype.cal = cal;
import localCache from '@/utils/localCache';
Vue.prototype.localCache = localCache;